export enum BillingTypeEnum {
  notDefined = 0,
  clientPays = 1,
  firmPays = 2,
}
